// IELTS Mock 2 — Academic Writing (harder than Mock 3: map comparison + two-part essay)
// Same shape as IELTS_DATA_WRITING in ../IeltsWriting.js. `mock` is forwarded to
// /api/scoring/writing-validate so it is checked against this mock's reference points.
const IELTS_MOCK2_WRITING = {
  title: "Academic Writing Practice Test 2",
  tasks: [
    {
      id: "task1",
      mock: 2,
      title: "Task 1: Report (20 min)",
      prompt:
        "The maps below show the town of Ferndale in 1995 and today. Summarise the information by selecting and reporting the main features, and make comparisons where relevant.",
      image: "/images/ielts-mock2/writing_task1_town_maps.svg",
      minWords: 150,
      keywords: ["map", "town", "ferndale", "1995", "farmland", "housing", "factory", "apartment", "school", "park", "woodland", "shopping", "bridge", "replac", "chang"],
      diagramType: "map"
    },
    {
      id: "task2",
      mock: 2,
      title: "Task 2: Essay (40 min)",
      prompt:
        "In many countries, the proportion of older people in the population is steadily increasing. What problems might this cause for individuals and for society? What measures could be taken to reduce these problems? Give reasons for your answer and include any relevant examples from your own knowledge or experience.",
      minWords: 250,
      keywords: ["older", "elderly", "age", "population", "problem", "health", "pension", "care", "society", "retire", "measure", "government"]
    }
  ]
};

export default IELTS_MOCK2_WRITING;
